"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundPreloadImage = exports.PreloadImageBase = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var React = __importStar(require("react"));
var EqualityComparers_1 = require("icf-search-client-shared/lib/EqualityComparers");
var observables_1 = require("icf-search-client-shared/lib/observables");
var PerformerItem_1 = require("../components/PerformerItem");
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("./Ioc");
var PreloadImageBase = /** @class */ (function (_super) {
    __extends(PreloadImageBase, _super);
    function PreloadImageBase() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this._unmounted = false;
        return _this;
    }
    PreloadImageBase.prototype._loadImage = function (src_1) {
        return __awaiter(this, arguments, void 0, function (src, fallbackSrcIndex) {
            var loadedSrc, _e_1, fallbackSrc;
            var _a;
            if (fallbackSrcIndex === void 0) { fallbackSrcIndex = 0; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.props.loader.loadAsset(src)];
                    case 1:
                        loadedSrc = _b.sent();
                        if (this._unmounted) {
                            return [2 /*return*/];
                        }
                        this._loadState.value = {
                            loaded: true,
                            failed: false,
                            src: loadedSrc,
                        };
                        return [3 /*break*/, 3];
                    case 2:
                        _e_1 = _b.sent();
                        if (this._unmounted) {
                            return [2 /*return*/];
                        }
                        // TODO: Cardinality nightmare
                        (_a = this.props.statsdClient) === null || _a === void 0 ? void 0 : _a.count("thumbnailFailure." + (0, PerformerItem_1.sanitizeThumbnailUrlForStatsD)(this.props.src));
                        fallbackSrc = null;
                        if (Array.isArray(this.props.fallbackSrcs)) {
                            if (fallbackSrcIndex !== this.props.fallbackSrcs.length - 1) {
                                this._loadImage(this.props.fallbackSrcs[fallbackSrcIndex], fallbackSrcIndex + 1);
                                return [2 /*return*/];
                            }
                            fallbackSrc = this.props.fallbackSrcs[fallbackSrcIndex];
                        }
                        this._loadState.value = {
                            loaded: true,
                            failed: true,
                            src: fallbackSrc,
                        };
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PreloadImageBase.prototype.componentDidMount = function () {
        var _this = this;
        this._loadState = new observables_1.Observable({ loaded: false, failed: false, src: null }, EqualityComparers_1.deepEqualityComparer);
        this._loadStateSubscription = this._loadState.subscribe(function () { return _this.forceUpdate(); });
        this._loadImage(this.props.src);
    };
    PreloadImageBase.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.src !== this.props.src ||
            JSON.stringify(prevProps.fallbackSrcs) !== JSON.stringify(this.props.fallbackSrcs)) {
            this._loadState.value = { loaded: false, failed: false, src: null };
            this._loadImage(this.props.src);
        }
    };
    PreloadImageBase.prototype.componentWillUnmount = function () {
        this._loadStateSubscription.dispose();
        this._loadState.dispose();
        this._unmounted = true;
    };
    PreloadImageBase.prototype.render = function () {
        var state = this._loadState ? this._loadState.value : { loaded: false, failed: false, src: null };
        return this.props.children(state.loaded, state.src);
    };
    PreloadImageBase = __decorate([
        (0, Ioc_1.connectContextsToProps)({
            loader: Contexts_1.IRemoteAssetLoaderContext,
        })
    ], PreloadImageBase);
    return PreloadImageBase;
}(React.Component));
exports.PreloadImageBase = PreloadImageBase;
// TODO: Should've been renamed when it was switched over to an img element (DEV-53125)
var BackgroundPreloadImage = function (p) {
    return ((0, jsx_runtime_1.jsx)(PreloadImageBase, { src: p.src, fallbackSrcs: p.fallbackSrcs, statsdClient: p.statsdClient, children: function (loaded, src) {
            var _a;
            // TODO: What to do when there's no src?
            // TODO: Also, this is supposed to be returning a ref, isn't it?
            return (_a = p.children) === null || _a === void 0 ? void 0 : _a.call(p, loaded, function (el) {
                return el === null || el === void 0 ? void 0 : el.setAttribute("src", loaded ? src : undefined);
            });
        } }));
};
exports.BackgroundPreloadImage = BackgroundPreloadImage;
exports.BackgroundPreloadImage.defaultProps = {
    children: function (_, ref) { return (0, jsx_runtime_1.jsx)("div", { ref: ref }); },
};
//# sourceMappingURL=PreloadImage.js.map